import { CreateDailyMissionRequest, DailyMissionKind } from "../store/types"

export type DailyMissionValidationError =
  | { kind: "kind"; message: string }
  | { kind: "taskToken"; message: string }
  | { kind: "title"; message: string }
  | { kind: "descriptionTmpl"; message: string }
  | { kind: "rewardUsd"; message: string }
  | { kind: "requiredCount"; message: string }
  | { kind: "windowDays"; message: string }

export type DailyMissionDraft = Partial<CreateDailyMissionRequest>;

const VALID_KINDS: DailyMissionKind[] = [
  DailyMissionKind.WATCH_AD,
  DailyMissionKind.DAILY_TASK,
  DailyMissionKind.LOGIN_STREAK,
]

export const validateDailyMission = (
  draft: DailyMissionDraft,
): DailyMissionValidationError | null => {
  if (!draft.kind || !VALID_KINDS.includes(draft.kind)) {
    return { kind: "kind", message: "Kind must be one of WATCH_AD, DAILY_TASK, LOGIN_STREAK" }
  }

  if (!draft.taskToken || !draft.taskToken.trim()) {
    return { kind: "taskToken", message: "Task Token is required" }
  }

  if (!draft.title || !draft.title.trim()) {
    return { kind: "title", message: "Title is required" }
  }

  if (!draft.descriptionTmpl || !draft.descriptionTmpl.trim()) {
    return { kind: "descriptionTmpl", message: "Description template is required" }
  }

  if (typeof draft.rewardUsd !== "number" || Number.isNaN(draft.rewardUsd) || draft.rewardUsd <= 0) {
    return { kind: "rewardUsd", message: "Reward (USD) must be greater than 0" }
  }

  if (
    typeof draft.requiredCount !== "number"
    || !Number.isInteger(draft.requiredCount)
    || draft.requiredCount < 1
  ) {
    return { kind: "requiredCount", message: "Required count must be an integer >= 1" }
  }

  if (draft.windowDays !== undefined && draft.windowDays !== null) {
    if (
      typeof draft.windowDays !== "number"
      || !Number.isInteger(draft.windowDays)
      || draft.windowDays <= 0
    ) {
      return { kind: "windowDays", message: "Window (days) must be a positive integer or empty" }
    }
  }

  return null
}
